export default "__VITE_ASSET__Czl72i9c__"